import React from "react";

function Button({ name, icon, purpose, btnCss, iconCss }) {
  return (
    <button
      onClick={purpose}
      className={`flex items-center gap-1 px-2 py-1 ${btnCss}`}
    >
      <div className={`${iconCss ? iconCss : ""}`}>{icon && icon}</div>
      <span className="flex py-1  w-full justify-center">{name}</span>
    </button>
  );
}

export default Button;
